import { render } from "./editProfilePictureComponent.vue?vue&type=template&id=0ff3b740"
import script from "./editProfilePictureComponent.vue?vue&type=script&lang=js"
export * from "./editProfilePictureComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__